<template>
    <div>
        <!-- <Exception type="403" img-color :desc="'抱歉，你无权访问该页面'" :back-text="'返回首页'" /> -->
        <div class="exception">
            <div class="exception-img">
                <div class="exception-img-element" :class="`img${name}`"></div>
            </div>
            <div class="exception-content">
                <h1>{{name}}</h1>
                <div class="exception-content-desc">{{desc}}</div>
                <div class="exception-content-actions">
                    <van-button @click="$router.push('/')" type="info" size="small">返回首页</van-button>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    export default {
        name: 'error',
        props: {
            name: String,
            desc: String
        }
    }
</script>

<style lang="less">
.exception {
    padding: 80px 40px;
    height: 80%;
    .exception-img {
        width: 100%;
        height: 300px;
        zoom: 1;
        &-element {
            width: 100%;
            height: 100%;
            &.img403 {
                background: url(../assets/icon-403-color.svg) center no-repeat;
                background-size: contain;
            }
            &.img404 {
                background: url(../assets/icon-404-color.svg) center no-repeat;
                background-size: contain;
            }
            &.img500 {
                background: url(../assets/icon-500-color.svg) center no-repeat;
                background-size: contain;
            }
        }
    }
    .exception-content {
        text-align: center;
        h1 {
            margin-top: 60px;
            margin-bottom: 34px;
            color: #515a6e;
            font-weight: 600;
            font-size: 82px;
            line-height: 82px;
        }
        .exception-content-desc {
            margin-bottom: 56px;
            color: #808695;
            font-size: 20px;
            line-height: 28px;
        }
    }
}
</style>
